module.exports = __webpack_public_path__ + "img/pf.4d1fbde1.svg";